import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_KEYS } from '@/lib/config/constants';
import type { StoreSettings } from '@/types/domain';

const defaultSettings: StoreSettings = {
  storeName: 'My Store',
  currency: { code: 'KES', symbol: 'Ksh ', position: 'before' },
  defaultTaxRate: 0,
  taxInclusive: false,
  receipt: { showLogo: true, showBarcode: true },
};

interface SettingsState {
  settings: StoreSettings;
  setSettings(s: StoreSettings): void;
  patchSettings(p: Partial<StoreSettings>): void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      settings: defaultSettings,
      setSettings: (settings) => set({ settings }),
      patchSettings: (p) => set((s) => ({ settings: { ...s.settings, ...p } })),
    }),
    {
      name: STORAGE_KEYS.settings,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
